import React, {Fragment, useState} from "react";
import * as Sentry from "@sentry/browser";
import Loader from "../Utils/Loader";
import classes from "./antiFraudTable.module.css";

function formatDate(dateStr) {
    if (!dateStr) return "—";
    try {
        var d = new Date(dateStr);
        var pad = function (n) { return n < 10 ? "0" + n : "" + n; };
        return pad(d.getDate()) + "." + pad(d.getMonth() + 1) + "." + d.getFullYear() +
            " " + pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());
    } catch (e) {
        Sentry.captureException(e);
        return dateStr;
    }
}

function getCheckTypeLabel(checkType) {
    switch (checkType) {
        case "payment":
            return "Платёж";
        case "payout":
            return "Выплата";
        default:
            return checkType || "—";
    }
}

function getResultClass(result) {
    switch (result) {
        case "ok":
            return classes.ResultOk;
        case "blocked":
            return classes.ResultBlocked;
        case "error":
            return classes.ResultError;
        default:
            return "";
    }
}

function getResultLabel(result) {
    switch (result) {
        case "ok":
            return "ОК";
        case "blocked":
            return "Заблокировано";
        case "error":
            return "Ошибка";
        default:
            return result || "—";
    }
}

function getPhoneOrCard(row) {
    if (row.checkContext) {
        if (row.checkContext.phoneMasked) return row.checkContext.phoneMasked;
        if (row.checkContext.cardPanMasked) return row.checkContext.cardPanMasked;
    }
    return "—";
}

function AntiFraudTableRow({row}) {
    var [isOpened, setIsOpened] = useState(false);

    return (
        <Fragment>
            <tr className={classes.Row} onClick={function () { setIsOpened(!isOpened); }}>
                <td>{row.id}</td>
                <td>{formatDate(row.createdAt)}</td>
                <td>{row.merchantName || "—"}</td>
                <td>{getCheckTypeLabel(row.checkType)}</td>
                <td>{getPhoneOrCard(row)}</td>
                <td>{row.clientIp || "—"}</td>
                <td><span className={getResultClass(row.result)}>{getResultLabel(row.result)}</span></td>
                <td>{row.blockedReason || "—"}</td>
                <td>{row.totalTimeMs != null ? row.totalTimeMs + " мс" : "—"}</td>
            </tr>
            {isOpened && (
                <tr className={classes.DetailRow}>
                    <td colSpan={9}>
                        <table className={classes.DetailTable}>
                            <tbody>
                            {row.blockedBy && (
                                <tr>
                                    <td className={classes.DetailLabel}>Заблокировано провайдером:</td>
                                    <td>{row.blockedBy}</td>
                                </tr>
                            )}
                            {row.blockedKind && (
                                <tr>
                                    <td className={classes.DetailLabel}>Тип блокировки:</td>
                                    <td>{row.blockedKind}</td>
                                </tr>
                            )}
                            {row.transactionId && (
                                <tr>
                                    <td className={classes.DetailLabel}>Идентификатор транзакции:</td>
                                    <td>{row.transactionId}</td>
                                </tr>
                            )}
                            {row.terminalName && (
                                <tr>
                                    <td className={classes.DetailLabel}>Терминал:</td>
                                    <td>{row.terminalName}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>

                        {row.providersChecked && row.providersChecked.length > 0 && (
                            <div>
                                <strong style={{fontSize: ".8125rem", display: "block", marginTop: 10, marginBottom: 4}}>
                                    Провайдеры проверки:
                                </strong>
                                <table className={classes.ProvidersTable}>
                                    <thead>
                                    <tr>
                                        <th>Провайдер</th>
                                        <th>Результат</th>
                                        <th>Время (мс)</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {row.providersChecked.map(function (p, i) {
                                        return (
                                            <tr key={i}>
                                                <td>{p.provider || "—"}</td>
                                                <td>
                                                    <span className={getResultClass(p.result)}>
                                                        {getResultLabel(p.result)}
                                                    </span>
                                                </td>
                                                <td>{p.timeMs != null ? p.timeMs : "—"}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </td>
                </tr>
            )}
        </Fragment>
    );
}

function AntiFraudTable({data, isLoading}) {
    return (
        <div className={classes.Card}>
            <div className={classes.Table}>
                <table>
                    <thead>
                    <tr>
                        <th>Идентификатор</th>
                        <th>Дата</th>
                        <th>Мерчант</th>
                        <th>Тип</th>
                        <th>Телефон/Карта</th>
                        <th>IP</th>
                        <th>Результат</th>
                        <th>Причина</th>
                        <th>Время</th>
                    </tr>
                    </thead>
                    <tbody>
                    {data && data.length > 0 ? (
                        isLoading ? (
                            data.map(function (row) {
                                return <AntiFraudTableRow key={row.id} row={row}/>;
                            })
                        ) : (
                            <tr>
                                <td colSpan={9} style={{textAlign: "center"}}>
                                    <Loader/>
                                </td>
                            </tr>
                        )
                    ) : (
                        <tr>
                            <td colSpan={9}>
                                <div className={classes.Empty}>
                                    <h5>Нет данных</h5>
                                </div>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default AntiFraudTable;



// WEBPACK FOOTER //
// ./src/Components/AntiFraudTable/index.js